
import InstanceBox from './index.vue';
import { dialog } from '@/plugins/dialog/index'
export default function (options) {
  return dialog({
    props: {
      /** 收发货人信息并排两列，默认的 50% 宽度下每列会挤，固定一个够宽的 */
      width: '900px',
    },
    content() {
      return <InstanceBox options={options} />
    }
  })
}